import {
  Grid,
  Typography,
  Stack,
  Button,
  IconButton,
  Box,
  FormControl,
  Select,
  TextField,
  Autocomplete,
  DialogActions,
  DialogContent,
  DialogTitle,
  InputLabel,
  MenuItem,
  DialogContentText
} from '@mui/material';
import LocalPrintshopIcon from '@mui/icons-material/LocalPrintshop';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import '../studylogStyles.scss';

import { useEffect, useState } from 'react';
import { archLevel } from 'src/data/config';
import { usePreferedDateFormat } from 'src/util/DateFormatter';
import { useGetCodeListDataQuery } from 'src/services/codeList';
import { useAppSelector } from 'src/store';
import { formatInput } from 'src/util/STR';
import { setConfirmExitValue } from 'src/store/confirmExitValue';
import { useEMREvaluation } from './useEMREvalustion';
import { showLoader, hideLoader } from 'src/store/Loader';
import { setMessage } from 'src/store/Message';
import { useAppDispatch } from 'src/store/hooks';
import moment from 'moment';
import { UI_TIME_ZONE } from 'src/constants/formats';
import printPdfWithViewer from 'src/components/common/PrintPdfWithViewer';
import { usePermissionWrapper } from 'src/components/hooks/usePermissionWrapper';
import { PopupComponent } from 'src/components/common/PopupComponent';
import Loader from 'src/components/common/Loader';
import { clearEMRId } from 'src/store/selectedEMR';
import { useFieldTranslation } from 'src/components/fields/useFieldTranslation';
import ESignConsentReAuth from 'src/components/common/ESignConsentReAuth';
import { useLazySetESignQuery } from 'src/services/ESignAPI';
import { useSelectedAppInfo } from 'src/util/SelectedAppInfo';
import { useValidUserForReAuth } from 'src/components/hooks/useValidUserForReAuth';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP
    }
  }
};

const EMREvaluationQuestionnaire = ({
  selectedEMRRow,
  setEMRGrid,
  setOpenEMRevaluation,
  setselectedEMRRow,
  getAllEMREvaluations,
  pageNumber,
  pageSize
}: any) => {
  const { isValidUserForReAuth } = useValidUserForReAuth();
  const dispatch = useAppDispatch();
  const disabledSiteSection = archLevel == 'site' ? false : true;
  const { userPreferedDateFormat, getCurrentDateInPreferedFormat } = usePreferedDateFormat();
  const [openSignConsent, setOpenSignConsent] = useState(false);
  const [signControlObject, setSignControlObject] = useState({
    site: { is_investigator_sign: false, id: '' },
    sponsor: { is_sponsor_sign: false, id: '' }
  });
  const { applicationModuleSection, unSavedWarning } = useFieldTranslation();
  const { selectedAppSection } = useSelectedAppInfo();
  const { data: seCode } = useGetCodeListDataQuery('SEMATYP');
  const { data: semCode } = useGetCodeListDataQuery('SEMINFO');
  const [preEMR, setPreEMR] = useState(false);
  const [ongoingEMR, setOngoingEMR] = useState(false);
  const [typeOfAccess, setTypeAccess] = useState(false);
  const [openOtherSpecify, setOpenOtherSpecify] = useState(false);
  const user = useAppSelector(state => `${state.user.user?.firstName} ${state.user.user?.lastName}`);
  const { getPreferredDateTimeInLocal } = usePreferedDateFormat();
  const [isSaveEnable, setIssaveEnable] = useState(false);
  const [isPublishEnable, setIsPublishEnable] = useState(false);
  const [isPublishETMFEnable, setIsPublishETMFEnable] = useState(false);
  const { checkPermission } = usePermissionWrapper();
  const createNewEMRpermission = checkPermission('create_new_emr_evaluation_quesyionnaire');
  const signSponsorPermission = checkPermission('sign_emr_sponsor');
  const signSitePermission = checkPermission('sign_emr_site');
  const [openEMRVersionPopup, setOpenEMRVersionPopup] = useState(false);
  const [openConfirmExit, setOpenConfirmExit] = useState(false);
  const [isChanged, setIsChanged] = useState(false);
  const siteInitialData = {
    visit_type: '',
    sub_type: '',
    monitoring_visit_id: '',
    start_date: '',
    end_date: '',
    visit_purpose: '',
    date_completed: '',
    completed_by: '',
    system: '',
    info_text: '',
    info_select: '',
    other_specify: '',
    info_note: '',
    eval_type: null,
    security: null,
    security_comments: '',
    security_note: '',
    change: null,
    change_comments: '',
    change_note: '',
    access: null,
    access_comments: '',
    access_type: '',
    agreement: null,
    agreement_comments: '',
    training: null,
    training_comments: '',
    other_means: null,
    other_means_comments: '',
    pi_comply: null,
    pi_comply_comments: '',
    pi_approval: '',
    emr_event_id: '',
    created_by: user,
    emr_publish_version_isf: null
  };

  const sponsorInitData = {
    date_eval: '',
    eval_by: '',
    type: null,
    pre_study_eval: null,
    ongoing_eval: null,
    eval_comments: '',
    cra_access: null,
    updated_by: user
  };
  const [siteEMRData, setSiteEMRData] = useState<any>({ ...siteInitialData });
  const [sponsorEMRData, setSponsorEMRData] = useState<any>({ ...sponsorInitData });
  const [accessType, setaccessType] = useState<any>([]);
  const [accessTypeCopy, setaccessTypeCopy] = useState<any>([]);
  const [infoSelect, setinfoSelect] = useState<any>([]);
  const [isSiteUpdated, setIsSiteUpdated] = useState(false);

  useEffect(() => {
    if (seCode) {
      setaccessTypeCopy(seCode);
      const mockArr: any = [];
      seCode.map((obj: any) => {
        mockArr.push({
          label: obj.code_list_value,
          value: obj.code_list_value,
          title: obj.code_list_value,
          key: obj.id,
          id: obj.id
        });
      });
      setaccessType(mockArr);
    }
  }, [seCode]);

  useEffect(() => {
    if (semCode) {
      const mockArr: any = [];
      semCode.map((obj: any) => {
        mockArr.push({
          label: obj.code_list_value,
          value: obj.code_list_value,
          title: obj.code_list_value,
          key: obj.id,
          id: obj.id
        });
      });
      setinfoSelect(mockArr);
    }
  }, [semCode]);

  const handlePreStudyEMR = () => {
    setPreEMR(true);
    setOngoingEMR(false);
    setTypeAccess(false);
  };
  const handleOngoingStudyEMR = () => {
    setOngoingEMR(true);
    setPreEMR(false);
    setTypeAccess(false);
  };
  const handleSiteEmr = () => {
    setIsChanged(true);
    setTypeAccess(true);
    setSponsorEMRData({ ...sponsorEMRData, cra_access: '' });
  };
  const handleSDV = () => {
    setIsChanged(true);
    setTypeAccess(false);
    setSponsorEMRData({ ...sponsorEMRData, cra_access: '' });
  };

  const handleCheck = (e: any) => {
    setIsChanged(true);
    const data = e.target.value;
    const formattedVal = typeof data === 'string' ? formatInput(data) : data;
    setIssaveEnable(true);

    if (archLevel == 'site') {
      setSiteEMRData({
        ...siteEMRData,
        [e.target.name]: formattedVal
      });
    } else {
      if (e.target.name == 'type') {
        setSponsorEMRData({
          ...sponsorEMRData,
          type: formattedVal,
          pre_study_eval: '',
          ongoing_eval: '',
          eval_comments: '',
          cra_access: ''
        });
      } else if (e.target.name == 'pre_study_eval') {
        setSponsorEMRData({
          ...sponsorEMRData,
          pre_study_eval: formattedVal,
          ongoing_eval: '',
          eval_comments: '',
          cra_access: ''
        });
      } else if (e.target.name == 'ongoing_eval') {
        setSponsorEMRData({
          ...sponsorEMRData,
          ongoing_eval: formattedVal,
          pre_study_eval: '',
          eval_comments: '',
          cra_access: ''
        });
      } else {
        setSponsorEMRData({
          ...sponsorEMRData,
          [e.target.name]: formattedVal
        });
      }
    }
    setConfirmExitValue(dispatch, true);
  };
  const handChangeAutocompleteInfoSelect = (event: any, values: any) => {
    setIsChanged(true);
    const selectedValues: any = [];
    setIssaveEnable(true);
    if (values) {
      values.map((item: any) => {
        selectedValues.push(item.title);
      });
    }
    if (selectedValues?.includes('Other')) {
      setOpenOtherSpecify(true);
      setSiteEMRData({
        ...siteEMRData,
        info_select: selectedValues.toString()
      });
    } else {
      setOpenOtherSpecify(false);
      setSiteEMRData({
        ...siteEMRData,
        info_select: selectedValues.toString(),
        other_specify: ''
      });
    }

    setConfirmExitValue(dispatch, true);
  };
  const handChangeAutocompleteAccessType = (event: any, values: any) => {
    setIsChanged(true);
    const selectedValues: any = [];
    setIssaveEnable(true);
    if (values) {
      values.map((item: any) => {
        selectedValues.push(item.title);
      });
    }
    if (archLevel == 'site') {
      setSiteEMRData({
        ...siteEMRData,
        access_type: selectedValues.toString()
      });
    } else {
      setSponsorEMRData({
        ...sponsorEMRData,
        cra_access: selectedValues.toString()
      });
    }
    setConfirmExitValue(dispatch, true);
  };
  const studyId: any = useAppSelector(state => state.site.selectedStudy);
  const selectedCountry = useAppSelector(state => state.site.selectedCountry);
  const selectedSite = useAppSelector(state => state.site.selectedSite);

  const {
    emrSiteData,
    emrSiteDataIsLoading,
    emrSponsorData,
    emrSponsorDataIsLoading,
    createSiteEMR,
    createSiteEMRError,
    createSiteEMRIsError,
    createSiteEMRIsLoading,
    createSiteEMRIsSuccess,
    updateSiteError,
    updateSiteIsError,
    updateSiteIsLoading,
    updateSiteIsSuccess,
    updateSponsorEMRIsSuccess,
    publishEMRError,
    publishEMRIsError,
    publishEMRIsLoading,
    publishEMRIsSuccess,
    publishEMRDataToETMF,
    getSiteEMREvaluationData,
    getSponsorEMREvaluationData,
    updateSponsorEMR,
    updateSiteEMR,
    publishToISFEMRData,
    publishISFEMR,
    publishISFEMRError,
    publishISFEMRIsLoading,
    publishISFEMRIsSuccess,
    createSponsorEMR,
    createSponsorEMRIsError,
    createSponsorEMRIsLoading,
    createSponsorEMRIsSuccess,
    newSponsorEMRversion,
    newSponsorEMRversionError,
    newSponsorEMRversionIsError,
    newSponsorEMRversionIsLoading,
    newSponsorEMRversionIsSuccess
  } = useEMREvaluation();

  const [setESignature] = useLazySetESignQuery();

  async function getEMREvalutionData() {
    getSiteEMREvaluationData({
      site_id: selectedSite,
      study_id: studyId,
      country: selectedCountry,
      event_id: selectedEMRRow.id,
      application: archLevel == 'sponsor' ? process.env.REACT_APP_NAME : process.env.REACT_APP_NAME_TEMP
    });
    if (archLevel == 'sponsor') {
      getSponsorEMREvaluationData({
        site_id: selectedSite,
        study_id: studyId,
        country: selectedCountry,
        event_id: selectedEMRRow.id,
        application: process.env.REACT_APP_NAME
      });
    }
  }

  useEffect(() => {
    if (selectedEMRRow.id) {
      getEMREvalutionData();
    }
  }, [selectedEMRRow]);

  useEffect(() => {
    if (emrSiteData) {
      setSiteEMRData({ ...siteEMRData, ...emrSiteData });
      setIsSiteUpdated(true);
      if (emrSiteData?.pi_sign != null && emrSiteData?.pi_sign != '' && archLevel === 'site') {
        setIsPublishEnable(true);
      } else {
        setIsPublishEnable(false);
      }
    }
    const filtered = emrSiteData?.info_select?.split(',').find((ele: any) => ele === 'Other');
    if (filtered) {
      setOpenOtherSpecify(true);
    } else {
      setOpenOtherSpecify(false);
    }
  }, [emrSiteData]);

  useEffect(() => {
    if (emrSponsorData) {
      if (emrSponsorData?.type?.includes('Prestudy')) {
        setPreEMR(true);
        setOngoingEMR(false);
      } else if (emrSponsorData?.type?.includes('Ongoing study')) {
        setPreEMR(false);
        setOngoingEMR(true);
      }
      if (
        emrSponsorData?.pre_study_eval ==
          'Site EMR Appropriate or alternative solution found, proceed with site selection' ||
        emrSponsorData?.ongoing_eval ==
          'Site EMR Appropriate or alternative solution found, proceed with site selection'
      ) {
        setTypeAccess(true);
      } else {
        setTypeAccess(false);
      }
      setSponsorEMRData({ ...sponsorEMRData, ...emrSponsorData });
      if (emrSponsorData?.cra_sign != null && emrSponsorData?.cra_sign != '' && archLevel === 'sponsor') {
        setIsPublishETMFEnable(true);
      } else {
        setIsPublishETMFEnable(false);
      }
    }
  }, [emrSponsorData]);

  const handleEMRFormSave = () => {
    if (archLevel == 'site') {
      if (isSiteUpdated) {
        const upDatePayload = {
          visit_type: selectedEMRRow.visit_type,
          sub_type: selectedEMRRow.sub_type,
          monitoring_visit_id: selectedEMRRow.monitoring_visit_id,
          schedule_start_date: selectedEMRRow.start_date,
          schedule_end_date: selectedEMRRow?.end_date,
          emr_event_id: selectedEMRRow.id,
          visit_no: selectedEMRRow.visit_no,
          visit_purpose: siteEMRData?.visit_purpose,
          date_completed: moment(new Date()).format(`YYYY-MM-DD`),
          completed_by: user,
          system: siteEMRData?.system,
          info_text: siteEMRData?.info_text,
          info_select: siteEMRData?.info_select,
          other_specify: siteEMRData?.other_specify,
          info_note: siteEMRData?.info_note,
          eval_type: siteEMRData?.eval_type,
          security: siteEMRData?.security,
          security_comments: siteEMRData?.security_comments,
          security_note: siteEMRData?.security_note,
          change: siteEMRData?.change,
          change_comments: siteEMRData?.change_comments,
          change_note: siteEMRData?.change_note,
          access: siteEMRData?.access,
          access_comments: siteEMRData?.access_comments,
          access_type: siteEMRData?.access_type,
          agreement: siteEMRData?.agreement,
          agreement_comments: siteEMRData?.agreement_comments,
          training: siteEMRData?.training,
          training_comments: siteEMRData?.training_comments,
          other_means: siteEMRData?.other_means,
          other_means_comments: siteEMRData?.other_means_comments,
          pi_comply: siteEMRData?.pi_comply,
          pi_comply_comments: siteEMRData?.pi_comply_comments,
          pi_approval: siteEMRData?.pi_approval,
          pi_approval_datetime: null,
          pi_sign: '',
          pi_sign_reason: '',
          updated_by: user,
          id: siteEMRData?.id,
          emr_publish_version_isf: siteEMRData?.emr_publish_version_isf
        };
        updateSiteEMR({
          site_id: selectedSite,
          study_id: studyId,
          country: selectedCountry,
          application: archLevel == 'sponsor' ? process.env.REACT_APP_NAME : process.env.REACT_APP_NAME_TEMP,
          data: upDatePayload
        });
      } else {
        createSiteEMR({
          site_id: selectedSite,
          study_id: studyId,
          country: selectedCountry,
          application: archLevel == 'sponsor' ? process.env.REACT_APP_NAME : process.env.REACT_APP_NAME_TEMP,
          data: {
            ...siteEMRData,
            date_completed: moment(new Date()).format(`YYYY-MM-DD`),
            created_by: user,
            completed_by: user,
            schedule_start_date: null,
            schedule_end_date: null,
            visit_type: selectedEMRRow.visit_type,
            sub_type: selectedEMRRow.sub_type,
            monitoring_visit_id: selectedEMRRow.monitoring_visit_id,
            start_date: selectedEMRRow.start_date,
            end_date: selectedEMRRow?.end_date,
            emr_event_id: selectedEMRRow.id,
            visit_no: selectedEMRRow.visit_no
          }
        });
      }
    } else {
      if (emrSponsorData) {
        const obj = {
          date_eval: moment(new Date()).format(`YYYY-MM-DD`),
          eval_by: user,
          type: sponsorEMRData?.type,
          pre_study_eval: sponsorEMRData.pre_study_eval,
          ongoing_eval: sponsorEMRData?.ongoing_eval,
          eval_comments: sponsorEMRData?.eval_comments,
          cra_access: sponsorEMRData?.cra_access != '' ? sponsorEMRData?.cra_access : null,
          updated_by: user,
          id: sponsorEMRData?.id
        };
        updateSponsorEMR({
          site_id: selectedSite,
          study_id: studyId,
          country: selectedCountry,
          application: archLevel == 'sponsor' ? process.env.REACT_APP_NAME : process.env.REACT_APP_NAME_TEMP,
          data: obj
        });
      } else {
        const payload = {
          visit_type: selectedEMRRow.visit_type,
          sub_type: selectedEMRRow.sub_type,
          monitoring_visit_id: selectedEMRRow.monitoring_visit_id,
          schedule_start_date: selectedEMRRow.start_date,
          schedule_end_date: selectedEMRRow?.end_date,
          emr_event_id: selectedEMRRow.id,
          visit_no: selectedEMRRow.visit_no,
          date_eval: moment(new Date()).format(`YYYY-MM-DD`),
          eval_by: user,
          type: sponsorEMRData?.type,
          pre_study_eval: sponsorEMRData.pre_study_eval,
          ongoing_eval: sponsorEMRData?.ongoing_eval,
          eval_comments: sponsorEMRData?.eval_comments,
          cra_access: sponsorEMRData?.cra_access != '' ? sponsorEMRData?.cra_access : null,
          created_by: user
        };
        createSponsorEMR({
          site_id: selectedSite,
          study_id: studyId,
          country: selectedCountry,
          application: archLevel == 'sponsor' ? process.env.REACT_APP_NAME : process.env.REACT_APP_NAME_TEMP,
          data: payload
        });
      }
    }
    setConfirmExitValue(dispatch, false);
  };

  const handleEMREvaluationSign = async (data: any = {}) => {
    if (data.success) {
      if (!isValidUserForReAuth(data.records.user_name)) {
        dispatch(setMessage({ msgDetails: `Please e-sign with the logged in username`, severity: 'error' }));
      } else {
        setOpenSignConsent(false);
        dispatch(showLoader());
        let dataObj = {
          username: data.records.user_name,
          password: data.records.password,
          module_name: applicationModuleSection.emr,
          name_of_signature: '',
          name_of_date_field: '',
          id: '',
          columns_to_change: {}
        };
        if (signControlObject.site.is_investigator_sign) {
          dataObj = {
            ...dataObj,
            name_of_signature: 'pi_sign',
            name_of_date_field: 'pi_approval_datetime',
            id: signControlObject.site.id,
            columns_to_change: {
              ...dataObj.columns_to_change,
              pi_sign_reason: data.records.sign_reason,
              updated_by: user
            }
          };
        } else if (signControlObject.sponsor.is_sponsor_sign) {
          dataObj = {
            ...dataObj,
            name_of_signature: 'cra_sign',
            name_of_date_field: 'cra_sign_datetime',
            id: signControlObject.sponsor.id,
            columns_to_change: {
              ...dataObj.columns_to_change,
              cra_sign_reason: data.records.sign_reason,
              updated_by: user
            }
          };
        }
        const signatureResponse: any = await setESignature({
          site_id: selectedSite,
          study_id: studyId,
          country: selectedCountry,
          application: archLevel == 'sponsor' ? process.env.REACT_APP_NAME : process.env.REACT_APP_NAME_TEMP,
          application_section: selectedAppSection,
          application_module_section: applicationModuleSection.studyLogs,
          data: dataObj
        });
        if (signatureResponse.isSuccess) {
          setSignControlObject({
            ...signControlObject,
            site: { ...signControlObject.site, is_investigator_sign: false, id: '' },
            sponsor: { ...signControlObject.sponsor, is_sponsor_sign: false, id: '' }
          });
          dispatch(
            setMessage({
              msgDetails: 'Signature done successfully.',
              severity: 'success'
            })
          );
          getEMREvalutionData();
          setIssaveEnable(false);
        } else if (signatureResponse.isError) {
          dispatch(setMessage({ msgDetails: `Authorization for ${data.records.user_name} failed`, severity: 'error' }));
        }
        dispatch(hideLoader());
      }
    }
  };

  const handleSiteSignature = () => {
    if (isChanged) {
      dispatch(
        setMessage({
          msgDetails: 'Questionnaire not yet saved',
          severity: 'info'
        })
      );
    } else {
      setOpenSignConsent(true);
      setSignControlObject({
        ...signControlObject,
        site: { ...signControlObject.site, is_investigator_sign: true, id: siteEMRData?.id },
        sponsor: { ...signControlObject.sponsor, is_sponsor_sign: false, id: '' }
      });
    }
  };

  const handleSponsorSignature = () => {
    if (isChanged) {
      dispatch(
        setMessage({
          msgDetails: 'Questionnaire not yet saved',
          severity: 'info'
        })
      );
    } else {
      setOpenSignConsent(true);
      setSignControlObject({
        ...signControlObject,
        site: { ...signControlObject.site, is_investigator_sign: false, id: '' },
        sponsor: { ...signControlObject.sponsor, is_sponsor_sign: true, id: sponsorEMRData?.id }
      });
    }
  };

  const publishData = async () => {
    if (archLevel == 'site') {
      publishToISF();
    } else {
      publishToEtmf();
    }
  };

  async function publishToEtmf() {
    let version = '1';
    version = sponsorEMRData?.tmf_publish_version + 1;
    await publishEMRDataToETMF({
      site_id: selectedSite,
      study_id: studyId,
      country: selectedCountry,
      emr_id: sponsorEMRData?.id,
      update: parseFloat(version) > 1 ? true : false,
      is_published: true,
      application: archLevel == 'sponsor' ? process.env.REACT_APP_NAME : process.env.REACT_APP_NAME_TEMP
    });
  }

  async function publishToISF() {
    let version = '1';
    version = siteEMRData?.emr_publish_version_isf + 1; // else version = '1';
    await publishToISFEMRData({
      site_id: selectedSite,
      study_id: studyId,
      country: selectedCountry,
      id: siteEMRData.id,
      update: parseFloat(version) > 1 ? true : false,
      is_published: true,
      application: archLevel == 'sponsor' ? process.env.REACT_APP_NAME : process.env.REACT_APP_NAME_TEMP
    });
  }

  const printEMRData = async () => {
    try {
      const options = {
        monitoring_visit_id: archLevel == 'site' ? siteEMRData?.id : sponsorEMRData?.id,
        template_name: archLevel == 'site' ? 'site_emr_questionnaire_isf' : 'site_emr_questionnaire',
        study_id: studyId,
        site_id: selectedSite,
        pathVariables: {
          country: selectedCountry,
          appName: archLevel === 'sponsor' ? process.env.REACT_APP_NAME : 'TSDA',
          time_zone_id: UI_TIME_ZONE
        }
      };
      let pdfOptions: any = {};
      if (selectedEMRRow?.major_version) {
        pdfOptions = {
          ...options,
          pathVariables: {
            version: selectedEMRRow?.major_version.toFixed(1),
            ...options.pathVariables
          }
        };
      } else {
        pdfOptions = options;
      }
      const printViewerApiString = selectedEMRRow.major_version
        ? 'get_imvChecklist_pdf_file_version'
        : 'get_imvChecklist_pdf_file';
      printPdfWithViewer(printViewerApiString, pdfOptions, 'application/pdf');

      setTimeout(function () {
        dispatch(hideLoader());
      }, 1500);
    } catch (error: any) {
      dispatch(setMessage({ msgDetails: 'Error while fetching pdf', severity: 'error' }));
    }
  };
  const handelBack = () => {
    if (isChanged) {
      setOpenConfirmExit(true);
    } else {
      setEMRGrid(true);
      setOpenEMRevaluation(false);
      setselectedEMRRow(null);
      getAllEMREvaluations(pageNumber * pageSize, pageSize);
      dispatch(clearEMRId());
    }
  };

  const handleClickNewEMRversion = () => {
    setOpenEMRVersionPopup(true);
  };

  const handleCreateNewEMRversion = () => {
    newSponsorEMRversion({
      site_id: selectedSite,
      study_id: studyId,
      country: selectedCountry,
      application: archLevel == 'sponsor' ? process.env.REACT_APP_NAME : process.env.REACT_APP_NAME_TEMP,
      emr_id: emrSponsorData?.id
    });
  };

  const handleCancel = () => {
    setOpenEMRVersionPopup(false);
  };

  useEffect(() => {
    if (createSiteEMRIsSuccess || updateSiteIsSuccess || updateSponsorEMRIsSuccess || createSponsorEMRIsSuccess) {
      dispatch(
        setMessage({
          msgDetails: 'Data updated successfully.',
          severity: 'success'
        })
      );
      setIssaveEnable(false);
      setOpenEMRVersionPopup(false);
      setIsChanged(false);
      getEMREvalutionData();
    }
  }, [createSiteEMRIsSuccess, updateSiteIsSuccess, updateSponsorEMRIsSuccess, createSponsorEMRIsSuccess]);

  useEffect(() => {
    if (newSponsorEMRversionIsSuccess) {
      dispatch(
        setMessage({
          msgDetails: 'New EMR version ready to modify.',
          severity: 'success'
        })
      );
      setOpenEMRVersionPopup(false);
      getEMREvalutionData();
    }
  }, [newSponsorEMRversionIsSuccess]);

  useEffect(() => {
    if (publishISFEMRIsSuccess) {
      dispatch(
        setMessage({
          msgDetails: 'successfully published to ISF repository',
          severity: 'success'
        })
      );
    } else if (publishEMRIsSuccess) {
      dispatch(
        setMessage({
          msgDetails: 'successfully published to ETMF repository',
          severity: 'success'
        })
      );
    }
    getEMREvalutionData();
  }, [publishISFEMRIsSuccess, publishEMRIsSuccess]);

  useEffect(() => {
    if (
      (!createSiteEMRIsLoading && createSiteEMRIsError) ||
      (!updateSiteIsLoading && updateSiteIsError) ||
      (!publishEMRIsLoading && publishEMRIsError) ||
      (!publishISFEMRIsLoading && publishISFEMRError) ||
      (!createSponsorEMRIsLoading && createSponsorEMRIsError) ||
      (!newSponsorEMRversionIsLoading && newSponsorEMRversionIsError)
    ) {
      const errorData: any =
        createSiteEMRError || updateSiteError || publishEMRError || publishISFEMR || newSponsorEMRversionError;
      if (
        errorData?.status == 500 ||
        errorData?.status == 502 ||
        errorData?.status == 503 ||
        errorData?.status == 'FETCH_ERROR'
      ) {
        dispatch(
          setMessage({
            msgDetails: `${errorData?.status} : Internal Server Error`,
            severity: 'error'
          })
        );
      } else if (errorData?.status == 403) {
        dispatch(
          setMessage({
            msgDetails: `${errorData?.status} : Forbbiden Access`,
            severity: 'error'
          })
        );
      } else if (errorData?.status == 404) {
        dispatch(
          setMessage({
            msgDetails: errorData?.data?.context?.message,
            severity: 'error'
          })
        );
      }
    }
  }, [
    createSiteEMRIsLoading,
    createSiteEMRIsError,
    updateSiteIsLoading,
    updateSiteError,
    publishEMRIsLoading,
    publishEMRIsError,
    publishISFEMRIsLoading,
    publishISFEMRError,
    createSponsorEMRIsLoading,
    createSponsorEMRIsError
  ]);

  useEffect(() => {
    if (
      createSiteEMRIsLoading ||
      updateSiteIsLoading ||
      publishEMRIsLoading ||
      publishISFEMRIsLoading ||
      createSponsorEMRIsLoading ||
      emrSiteDataIsLoading ||
      emrSponsorDataIsLoading
    ) {
      dispatch(showLoader());
    } else {
      dispatch(hideLoader());
    }
  }, [
    createSiteEMRIsLoading,
    updateSiteIsLoading,
    publishEMRIsLoading,
    publishISFEMRIsLoading,
    createSponsorEMRIsLoading,
    emrSiteDataIsLoading,
    emrSponsorDataIsLoading
  ]);

  return (
    <>
      <div>
        <Box className="mainBackBtnWrap">
          <Button onClick={() => handelBack()} startIcon={<ArrowBackIcon fontSize="small" />}>
            Back
          </Button>
        </Box>
      </div>
      <Grid container spacing={1} sx={{ mb: 1.5, alignItems: 'center' }}>
        <Loader />
        <Grid item>
          <Typography variant="h5" component="h5" sx={{ margin: 0, fontSize: '20px', fontWeight: 500 }}>
            EMR Evaluation Questionnaire
          </Typography>
        </Grid>
        <Grid item xs sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-end' }}>
          <Stack direction="row" spacing={1.5}>
            <Button
              variant="contained"
              style={{ textTransform: 'none' }}
              sx={{ alignSelf: 'center' }}
              disabled={
                archLevel == 'site'
                  ? !checkPermission('publish_isf_emr_evalution') || !isPublishEnable || siteEMRData?.is_published_isf
                  : !checkPermission('publish_etmf_emr_evalution') ||
                    !isPublishETMFEnable ||
                    sponsorEMRData?.tmf_is_published
              }
              onClick={publishData}
            >
              {archLevel == 'site' ? 'PUBLISH TO eISF' : 'PUBLISH TO eTMF'}
            </Button>
            {archLevel === 'sponsor' ? (
              <Button
                sx={{ alignSelf: 'center' }}
                disabled={!createNewEMRpermission || !emrSponsorData?.tmf_is_published}
                onClick={handleClickNewEMRversion}
              >
                Create new version
              </Button>
            ) : null}
            <Button disabled={!isSaveEnable} onClick={handleEMRFormSave} sx={{ alignSelf: 'center' }}>
              Save
            </Button>
            <IconButton
              disabled={
                (archLevel == 'site' && !siteEMRData?.is_published_isf) ||
                (archLevel == 'sponsor' && !sponsorEMRData?.tmf_is_published)
              }
              aria-label="Print"
              onClick={printEMRData}
              color="primary"
              sx={{ alignSelf: 'center' }}
            >
              <LocalPrintshopIcon />
            </IconButton>
          </Stack>
        </Grid>
      </Grid>

      <Box className="letterPage">
        <br />
        <br />
        <Typography>
          <strong>Date of Completion:</strong>{' '}
          {siteEMRData?.date_completed
            ? moment(siteEMRData?.date_completed).format(`${userPreferedDateFormat.toUpperCase()}`)
            : archLevel === 'site' && getCurrentDateInPreferedFormat()}
        </Typography>

        <Typography gutterBottom>
          <strong>Information completed on behalf of site by:</strong>{' '}
          {siteEMRData?.completed_by ? siteEMRData?.completed_by : archLevel === 'site' && user}
        </Typography>

        <Typography sx={{ mb: 1, pt: 2 }}>
          <strong>EMR System:</strong> &nbsp;{' '}
          <span style={{ width: '220px', display: 'inline-block' }}>
            <TextField
              id="emrsystem"
              name="system"
              value={siteEMRData?.system}
              disabled={disabledSiteSection || siteEMRData?.pi_sign}
              placeholder="System"
              variant="standard"
              className="salutationField"
              onChange={handleCheck}
              inputProps={{
                maxLength: 100
              }}
            />
          </span>
          <br />
        </Typography>

        <div className="formList">
          <h4 className="formSubHeader" style={{ marginBottom: '0' }}>
            The above named EMR System contains the following information:
          </h4>
          <Autocomplete
            disabled={disabledSiteSection || siteEMRData?.pi_sign}
            onChange={handChangeAutocompleteInfoSelect}
            multiple
            id="tags-standard"
            options={infoSelect}
            value={infoSelect?.filter((opt: any) => siteEMRData.info_select?.split(',').includes(opt.value))}
            getOptionLabel={(option: any) => option.title}
            renderInput={(params: any) => <TextField {...params} variant="standard" label="Specify" />}
          />
          <br />
          {openOtherSpecify ? (
            <TextField
              name="other_specify"
              id="specifyvalue"
              variant="standard"
              fullWidth
              label="Other Specify"
              margin="normal"
              value={siteEMRData?.other_specify}
              disabled={disabledSiteSection || siteEMRData?.pi_sign}
              onChange={handleCheck}
              inputProps={{
                maxLength: 199
              }}
            />
          ) : (
            ''
          )}
          <br />
          <Typography gutterBottom variant="body1" color="text.secondary">
            <strong>Note:</strong> If more than one EMR system is used at the investigator site, please complete a
            separate “Site EMR Risk Evaluation Questionnaire” for each system.
          </Typography>
        </div>

        <div className="formList">
          <h4 className="formSubHeader">Evaluation Type: (Select One)</h4>
          <FormControl>
            <RadioGroup
              value={siteEMRData?.eval_type}
              name="eval_type"
              onChange={handleCheck}
              aria-labelledby="Evaluation-Type-group-label"
            >
              <FormControlLabel
                value="Pre-study EMR system evaluation"
                disabled={disabledSiteSection || siteEMRData?.pi_sign}
                control={<Radio />}
                label="Pre-study EMR system evaluation"
              />
              <FormControlLabel
                value="Ongoing study EMR system evaluation for all significant changes, upgrades or replacements of an EMR system"
                disabled={disabledSiteSection || siteEMRData?.pi_sign}
                control={<Radio />}
                label="Ongoing study EMR system evaluation for all significant changes, upgrades or replacements of an EMR system"
              />
            </RadioGroup>
          </FormControl>
        </div>

        <div className="formList mb24">
          <h4 className="formSubHeader">Questionnaire</h4>
          <Grid container spacing={2} alignItems="start">
            <Grid item md={7}>
              <Typography sx={{ mt: 1 }}>
                1. Does the site`s EMR system support the following security requirements to access the system:
              </Typography>
            </Grid>
            <Grid item xs>
              <RadioGroup
                value={siteEMRData?.security}
                onChange={handleCheck}
                name="security"
                row
                aria-labelledby="Yes-No-label"
                sx={{ mr: -0.5 }}
              >
                <FormControlLabel
                  disabled={disabledSiteSection || siteEMRData?.pi_sign}
                  value="true"
                  control={<Radio />}
                  label="Yes"
                />
                <FormControlLabel
                  disabled={disabledSiteSection || siteEMRData?.pi_sign}
                  value="false"
                  control={<Radio />}
                  label="No"
                />
              </RadioGroup>
            </Grid>
            <Grid item md={3} mt={0.5}>
              <TextField
                id="comment"
                placeholder="Comment"
                variant="standard"
                fullWidth
                value={siteEMRData?.security_comments}
                disabled={disabledSiteSection || siteEMRData?.pi_sign}
                onChange={handleCheck}
                name="security_comments"
                inputProps={{
                  maxLength: 2000
                }}
              />
            </Grid>
          </Grid>
          <ul className="ulList-smalltext leftAlign">
            <li>Unique User IDs for each person (no group or department access)</li>
            <li>
              Confidential passwords including protections (e.g. alpha/numeric letters, minimum length, password
              expiration, limited log-in attempts and account maintenance)
            </li>
            <li>
              User session control including automatic “time-out” and /or procedural provisions that users are not to
              leave open data entry sessions
            </li>
          </ul>
        </div>

        <div className="formList mb24">
          <Grid container spacing={2} alignItems="start">
            <Grid item md={7}>
              <Typography sx={{ mt: 1 }}>
                2. If a change is made to data in the EMR, will the system identify when the change was made
                (date/time), who made the change, and retain the original data?
              </Typography>
            </Grid>
            <Grid item xs>
              <RadioGroup
                onChange={handleCheck}
                name="change"
                value={siteEMRData?.change}
                row
                aria-labelledby="Yes-No-label"
                sx={{ mr: -0.5 }}
              >
                <FormControlLabel
                  disabled={disabledSiteSection || siteEMRData?.pi_sign}
                  value="true"
                  control={<Radio />}
                  label="Yes"
                />
                <FormControlLabel
                  disabled={disabledSiteSection || siteEMRData?.pi_sign}
                  value="false"
                  control={<Radio />}
                  label="No"
                />
              </RadioGroup>
            </Grid>
            <Grid item md={3} mt={0.5}>
              <TextField
                onChange={handleCheck}
                name="change_comments"
                id="comment"
                placeholder="Comment"
                variant="standard"
                fullWidth
                value={siteEMRData?.change_comments}
                disabled={disabledSiteSection || siteEMRData?.pi_sign}
                inputProps={{
                  maxLength: 2000
                }}
              />
            </Grid>
          </Grid>
          <ul className="ulList-smalltext leftAlign">
            <li>
              Built-In system/application functionality that captures an audit trail in a human readable format (as
              opposed to computer readable).
            </li>
            <li>
              Implement and test a 3rd party solution (and associated procedure) to capture and store protected human
              readable key-stroke file(s).
            </li>
            <li>
              Procedure or documented process to maintain a paper based audit trail which captures the values associated
              with changes / edits made to EMR data.
            </li>
          </ul>
        </div>

        <div className="formList mb24">
          <Grid container spacing={2} alignItems="start">
            <Grid item md={7}>
              <Typography sx={{ mt: 1 }}>
                3. Will the monitor be granted access to the EMR system and receive their own individual account and
                confidential password?
              </Typography>
            </Grid>
            <Grid item xs>
              <RadioGroup
                onChange={handleCheck}
                name="access"
                value={siteEMRData?.access}
                row
                aria-labelledby="Yes-No-label"
                sx={{ mr: -0.5 }}
              >
                <FormControlLabel
                  value="true"
                  disabled={disabledSiteSection || siteEMRData?.pi_sign}
                  control={<Radio />}
                  label="Yes"
                />
                <FormControlLabel
                  value="false"
                  disabled={disabledSiteSection || siteEMRData?.pi_sign}
                  control={<Radio />}
                  label="No"
                />
              </RadioGroup>
            </Grid>
            <Grid item md={3} mt={0.5}>
              <TextField
                onChange={handleCheck}
                name="access_comments"
                id="comment"
                placeholder="Comment"
                variant="standard"
                fullWidth
                value={siteEMRData?.access_comments}
                disabled={disabledSiteSection || siteEMRData?.pi_sign}
                inputProps={{
                  maxLength: 2000
                }}
              />
            </Grid>
          </Grid>
        </div>

        <div className="formList mb24">
          <Grid container spacing={2} alignItems="start">
            <Grid item md={7}>
              <Typography sx={{ mt: 1 }}>4. Please specify type of access provided to CRA</Typography>
            </Grid>
            <Grid item md={5}>
              <FormControl variant="standard" fullWidth>
                <InputLabel id="demo-simple-select-standard-label">Type of Access</InputLabel>
                <Select
                  MenuProps={MenuProps}
                  disabled={disabledSiteSection || siteEMRData?.pi_sign}
                  labelId="demo-simple-select-standard-label"
                  name="access_type"
                  value={siteEMRData.access_type}
                  onChange={handleCheck}
                  label="Type of Access"
                >
                  {accessTypeCopy?.map((item: any) => {
                    return (
                      <MenuItem key={item.id} value={item.code_list_value}>
                        {item.code_list_value}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </Grid>
          </Grid>
        </div>
        <div className="formList mb24">
          <Grid container spacing={2} alignItems="start">
            <Grid item md={7}>
              <Typography sx={{ mt: 1 }}>5. Should an EMR agreement be signed by the Monitor to get access?</Typography>
            </Grid>
            <Grid item xs>
              <RadioGroup
                onChange={handleCheck}
                name="agreement"
                value={siteEMRData.agreement}
                row
                aria-labelledby="Yes-No-label"
                sx={{ mr: -0.5 }}
              >
                <FormControlLabel
                  value="true"
                  disabled={disabledSiteSection || siteEMRData?.pi_sign}
                  control={<Radio />}
                  label="Yes"
                />
                <FormControlLabel
                  value="false"
                  disabled={disabledSiteSection || siteEMRData?.pi_sign}
                  control={<Radio />}
                  label="No"
                />
              </RadioGroup>
            </Grid>
            <Grid item md={3} mt={0.5}>
              <TextField
                onChange={handleCheck}
                name="agreement_comments"
                value={siteEMRData.agreement_comments}
                id="comment"
                placeholder="Comment"
                variant="standard"
                fullWidth
                disabled={disabledSiteSection || siteEMRData?.pi_sign}
                inputProps={{
                  maxLength: 2000
                }}
              />
            </Grid>
          </Grid>
        </div>

        <div className="formList mb24">
          <Grid container spacing={2} alignItems="start">
            <Grid item md={7}>
              <Typography sx={{ mt: 1 }}>
                6. Will the monitor be trained on how to perform assigned tasks in the system?
              </Typography>
            </Grid>
            <Grid item xs>
              <RadioGroup
                onChange={handleCheck}
                name="training"
                value={siteEMRData.training}
                row
                aria-labelledby="Yes-No-label"
                sx={{ mr: -0.5 }}
              >
                <FormControlLabel
                  disabled={disabledSiteSection || siteEMRData?.pi_sign}
                  value="true"
                  control={<Radio />}
                  label="Yes"
                />
                <FormControlLabel
                  disabled={disabledSiteSection || siteEMRData?.pi_sign}
                  value="false"
                  control={<Radio />}
                  label="No"
                />
              </RadioGroup>
            </Grid>
            <Grid item md={3} mt={0.5}>
              <TextField
                onChange={handleCheck}
                name="training_comments"
                id="comment"
                placeholder="Comment"
                variant="standard"
                fullWidth
                value={siteEMRData.training_comments}
                disabled={disabledSiteSection || siteEMRData?.pi_sign}
                inputProps={{
                  maxLength: 2000
                }}
              />
            </Grid>
          </Grid>
        </div>

        <div className="formList mb24">
          <Grid container spacing={2} alignItems="start">
            <Grid item md={7}>
              <Typography sx={{ mt: 1 }}>
                7. If required, will the site provide access to the source data by another means such as printed
                certified copies of the source or supervised viewing of the electronic source with the site staff?
              </Typography>
            </Grid>
            <Grid item xs>
              <RadioGroup
                onChange={handleCheck}
                name="other_means"
                value={siteEMRData.other_means}
                row
                aria-labelledby="Yes-No-label"
                sx={{ mr: -0.5 }}
              >
                <FormControlLabel
                  disabled={disabledSiteSection || siteEMRData?.pi_sign}
                  value="true"
                  control={<Radio />}
                  label="Yes"
                />
                <FormControlLabel
                  disabled={disabledSiteSection || siteEMRData?.pi_sign}
                  value="false"
                  control={<Radio />}
                  label="No"
                />
              </RadioGroup>
            </Grid>
            <Grid item md={3} mt={0.5}>
              <TextField
                onChange={handleCheck}
                name="other_means_comments"
                value={siteEMRData.other_means_comments}
                id="comment"
                placeholder="Comment"
                variant="standard"
                disabled={disabledSiteSection || siteEMRData?.pi_sign}
                inputProps={{
                  maxLength: 2000
                }}
              />
            </Grid>
          </Grid>
        </div>

        <div className="formList mb24">
          <Grid container spacing={2} alignItems="start">
            <Grid item md={7}>
              <Typography sx={{ mt: 1 }}>
                8. Do you (Principal Investigator) understand and agree to comply with paper and electronic document
                retention requirements after study closure?
              </Typography>
            </Grid>
            <Grid item xs>
              <RadioGroup
                onChange={handleCheck}
                name="pi_comply"
                value={siteEMRData.pi_comply}
                row
                aria-labelledby="Yes-No-label"
                sx={{ mr: -0.5 }}
              >
                <FormControlLabel
                  disabled={disabledSiteSection || siteEMRData?.pi_sign}
                  value="true"
                  control={<Radio />}
                  label="Yes"
                />
                <FormControlLabel
                  disabled={disabledSiteSection || siteEMRData?.pi_sign}
                  value="false"
                  control={<Radio />}
                  label="No"
                />
              </RadioGroup>
            </Grid>
            <Grid item md={3} mt={0.5}>
              <TextField
                onChange={handleCheck}
                name="pi_comply_comments"
                value={siteEMRData.pi_comply_comments}
                id="comment"
                placeholder="Comment"
                variant="standard"
                fullWidth
                disabled={disabledSiteSection || siteEMRData?.pi_sign}
                inputProps={{
                  maxLength: 2000
                }}
              />
            </Grid>
          </Grid>
        </div>

        <Typography gutterBottom className="disabledTypography">
          <strong>Principal Investigator Approval: (Principal Investigator to Complete)</strong>
        </Typography>
        <Typography gutterBottom className="disabledTypography">
          I have reviewed this questionnaire and agree that the answers represent the current state at this site with
          respect to source data storage, electronic medical records, and how data will be made available to the Site
          Monitor.
        </Typography>

        <Typography gutterBottom className="disabledTypography">
          <strong>Principal Investigator Signature:</strong>
          <br />
        </Typography>
        <Grid container spacing={2} mb={3}>
          {!siteEMRData.pi_sign ? (
            <Grid item xs>
              <Button
                variant="contained"
                disabled={(disabledSiteSection && !signSitePermission) || !emrSiteData?.date_completed}
                color="primary"
                onClick={handleSiteSignature}
              >
                Sign
              </Button>
            </Grid>
          ) : (
            <Grid item md={10}>
              <div>
                <span className="signedInfo">
                  Signed by <strong>{siteEMRData?.pi_sign}</strong> on{' '}
                  <span color="text.secondary">{getPreferredDateTimeInLocal(siteEMRData?.pi_approval_datetime)}</span>{' '}
                  <br />
                  <span className="signReasonrow">
                    <span color="text.secondary">Reason:</span> &ldquo;{siteEMRData?.pi_sign_reason}
                    &rdquo;
                  </span>
                </span>
              </div>
            </Grid>
          )}
        </Grid>
        {disabledSiteSection ? (
          <div className="formList">
            <h4 className="formSubHeader">SPONSOR SECTION</h4>
            <Typography gutterBottom color="text.secondary">
              <strong>Date of evaluation:</strong>&nbsp;
              {sponsorEMRData?.date_eval
                ? moment(sponsorEMRData?.date_eval).format(`${userPreferedDateFormat.toUpperCase()}`)
                : archLevel === 'sponsor' && getCurrentDateInPreferedFormat()}
            </Typography>
            <Typography gutterBottom color="text.secondary">
              <strong>Evaluation performed by (CRA):</strong>&nbsp;
              {sponsorEMRData?.eval_by ? sponsorEMRData?.eval_by : archLevel === 'sponsor' && user}
            </Typography>
            <Grid container spacing={2} mb={2}>
              <Grid item md={3.25}>
                <Typography gutterBottom color="text.secondary">
                  <strong>Evaluation Type (Select One):</strong>
                </Typography>
              </Grid>
              <Grid item xs>
                <RadioGroup
                  onChange={handleCheck}
                  name="type"
                  value={sponsorEMRData.type}
                  aria-labelledby="Evaluation-type-select"
                  sx={{ mt: -1 }}
                >
                  <FormControlLabel
                    control={<Radio />}
                    value="Prestudy EMR system evaluation"
                    label="Prestudy EMR system evaluation"
                    onChange={handlePreStudyEMR}
                    disabled={sponsorEMRData?.cra_sign}
                  />
                  <FormControlLabel
                    control={<Radio />}
                    value="Ongoing study EMR system evaluation for all significant changes, upgrades or replacements of an EMR system"
                    label="Ongoing study EMR system evaluation for all significant changes, upgrades or replacements of an EMR system"
                    onChange={handleOngoingStudyEMR}
                    disabled={sponsorEMRData?.cra_sign}
                  />
                </RadioGroup>
              </Grid>
            </Grid>

            <Box sx={{ mb: 2.5 }}>
              {preEMR ? (
                <div className="formList">
                  <h4 className="formSubHeader" style={{ marginBottom: 1.5 }}>
                    For pre study EMR system evaluation outcome: (Select One)
                  </h4>
                  <FormControl>
                    <RadioGroup
                      name="pre_study_eval"
                      value={sponsorEMRData.pre_study_eval}
                      onChange={handleCheck}
                      aria-labelledby="preStudyEMR-group-label"
                    >
                      <FormControlLabel
                        value="Site EMR Appropriate or alternative solution found, proceed with site selection"
                        control={<Radio />}
                        label="Site EMR Appropriate or alternative solution found, proceed with site selection."
                        onChange={handleSiteEmr}
                        disabled={sponsorEMRData?.cra_sign}
                      />
                      <FormControlLabel
                        value="No appropriate solution for SDV found, site not selected"
                        control={<Radio />}
                        label="No appropriate solution for SDV found, site not selected"
                        onChange={handleSDV}
                        disabled={sponsorEMRData?.cra_sign}
                      />
                    </RadioGroup>
                  </FormControl>
                  <br />
                  <br />
                </div>
              ) : (
                ''
              )}
            </Box>

            <Box sx={{ mb: 2.5 }}>
              {ongoingEMR ? (
                <div className="formList">
                  <h4 className="formSubHeader" style={{ marginBottom: 1.5 }}>
                    Ongoing study EMR system evaluation for all significant changes, upgrades or replacements of an EMR
                    system: (Select One)
                  </h4>
                  <FormControl>
                    <RadioGroup
                      value={sponsorEMRData.ongoing_eval}
                      name="ongoing_eval"
                      onChange={handleCheck}
                      aria-labelledby="preStudyEMR-group-label"
                    >
                      <FormControlLabel
                        value="Site EMR Appropriate or alternative solution found, proceed with site selection"
                        control={<Radio />}
                        label="Site EMR Appropriate or alternative solution found, proceed with site selection."
                        onChange={handleSiteEmr}
                        disabled={sponsorEMRData?.cra_sign}
                      />
                      <FormControlLabel
                        value="No appropriate solution for SDV found for ongoing monitoring, raise Issue Escalation"
                        control={<Radio />}
                        label="No appropriate solution for SDV found for ongoing monitoring, raise Issue Escalation"
                        onChange={handleSDV}
                        disabled={sponsorEMRData?.cra_sign}
                      />
                    </RadioGroup>
                  </FormControl>
                </div>
              ) : (
                ''
              )}
            </Box>

            <Box>
              <TextField
                id="comments"
                name="eval_comments"
                value={sponsorEMRData.eval_comments}
                onChange={handleCheck}
                placeholder="Comments"
                variant="standard"
                fullWidth
                disabled={sponsorEMRData?.cra_sign}
                inputProps={{
                  maxLength: 2000
                }}
              />
              <br />
              <br />
              {typeOfAccess ? (
                <>
                  <Typography gutterBottom>
                    <strong>Type of access provided to monitor:</strong>
                  </Typography>
                  <Autocomplete
                    multiple
                    disabled={sponsorEMRData?.cra_sign}
                    onChange={handChangeAutocompleteAccessType}
                    id="tags-standard"
                    options={accessType}
                    defaultValue={
                      sponsorEMRData.cra_access
                        ? accessType?.filter((opt: any) => sponsorEMRData.cra_access.split(',').includes(opt.value))
                        : []
                    }
                    getOptionLabel={(option: any) => option.title}
                    renderInput={(params: any) => <TextField {...params} variant="standard" label="Select" />}
                  />
                </>
              ) : (
                ''
              )}
            </Box>
            <br />
            <Typography gutterBottom className="disabledTypography">
              <strong>Signature of Monitor:</strong>
              <br />
            </Typography>
            <Grid container spacing={2} mb={3}>
              {!sponsorEMRData.cra_sign ? (
                <Grid item xs>
                  <Button
                    variant="contained"
                    disabled={!signSponsorPermission || !emrSiteData?.pi_sign}
                    color="primary"
                    onClick={handleSponsorSignature}
                  >
                    Sign
                  </Button>
                </Grid>
              ) : (
                <Grid item md={10}>
                  <div>
                    <span className="signedInfo">
                      Signed by <strong>{sponsorEMRData?.cra_sign}</strong> on{' '}
                      <span color="text.secondary">
                        {getPreferredDateTimeInLocal(sponsorEMRData?.cra_sign_datetime)}
                      </span>{' '}
                      <br />
                      <span className="signReasonrow">
                        <span color="text.secondary">Reason:</span> &ldquo;{sponsorEMRData?.cra_sign_reason}
                        &rdquo;
                      </span>
                    </span>
                  </div>
                </Grid>
              )}
            </Grid>
          </div>
        ) : (
          ''
        )}
      </Box>
      <PopupComponent aria-labelledby="customized-dialog-title" open={openEMRVersionPopup} maxWidth="lg">
        <DialogTitle>Confirm</DialogTitle>
        <DialogContent>
          <Typography variant="body1">Are you sure do you want to create new version?</Typography>
        </DialogContent>
        <DialogActions>
          <Button className="grey-btn" onClick={handleCancel}>
            Cancel
          </Button>
          <Button onClick={handleCreateNewEMRversion}>Create</Button>
        </DialogActions>
      </PopupComponent>
      <>
        <PopupComponent
          open={openConfirmExit}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          className="confirm-modal"
          child
        >
          <DialogTitle id="alert-dialog-title">{'Confirm Exit'}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">{unSavedWarning}</DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => {
                setOpenConfirmExit(false);
              }}
              className="grey-btn"
            >
              Close
            </Button>
            <Button
              onClick={() => {
                setIsChanged(false);
                setOpenConfirmExit(false);
                setEMRGrid(true);
                setOpenEMRevaluation(false);
                setselectedEMRRow(null);
                getAllEMREvaluations(pageNumber * pageSize, pageSize);
                dispatch(clearEMRId());
              }}
            >
              Ok
            </Button>
          </DialogActions>
        </PopupComponent>
        {openSignConsent && (
          <ESignConsentReAuth
            openSignConsent={openSignConsent}
            setOpenSignConsent={setOpenSignConsent}
            handleConfirmSign={handleEMREvaluationSign}
          />
        )}
      </>
    </>
  );
};

export default EMREvaluationQuestionnaire;
